import HomeMap from './home-map';
export default HomeMap;